<template>
  <div class="banner-component"
       :class="[
         { 'has-title': bannerHasTitle, 'is-million-read': isMillionRead },
       ]"
  >
    <ym-swipe class="banner-swipe"
              :options="swiperOption"
              :style="style"
              ref="swiper"
              @click.native="handleClickSlider"
    >
      <ym-swipe-slide class="banner-item"
                      :class="[
                        { 'has-shadow': shadow },
                        { 'in-app': isAppWebView }
                      ]"
                      v-for="(item, index) in banner"
                      :key="index"
                      :style="style"
      >
        <ym-img class="banner-item-img"
                radius="4"
                :src="item.src"
                alt="banner 图"
                v-ym-report:[exposure]="item"
        />
        <div v-if="item.title && !isMillionRead"
             class="banner-item-title"
        >
          <div class="ym-ellipsis">
            {{ item.title }}
          </div>
        </div>
      </ym-swipe-slide>
      <template #pagination>
        <div class="swiper-pagination"></div>
      </template>
    </ym-swipe>
  </div>
</template>

<script>
  import { decorator, before } from 'ym-reporter-vue';
  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  import { addUnit, isAppWebView } from '@/utils';
  import SwiperLoopMixin from '@/mixins/swiper/loop';

  export default {
    name: 'Banner',
    mixins: [SwiperLoopMixin],
    components: {
      'ym-swipe': swiper,
      'ym-swipe-slide': swiperSlide,
    },
    data() {
      return {
        swiperOption: {
          slidesPerView: 'auto',
          spaceBetween: 15,
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          pagination: {
            el: '.swiper-pagination',
          },
        },
        isAppWebView: isAppWebView(),
      };
    },
    props: {
      banner: {
        type: Array,
        required: true,
      },
      options: {
        type: Object,
      },
      width: [Number, String],
      height: [Number, String],
      shadow: {
        type: Boolean,
        default: true,
      },
      recordName: String,
      isMillionRead: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      options(val) {
        this.setOptions(val);
      },
    },
    computed: {
      style() {
        const style = {};
        const { width, height } = this;
        if (width) {
          style.width = `${addUnit(width)}`;
        }
        if (height) {
          style.height = `${addUnit(height)}`;
        }
        return style;
      },
      swiperRefs() {
        if (this.$refs.swiper) {
          return this.$refs.swiper.swiper;
        }
        return null;
      },
      exposure() {
        const { recordName } = this;
        return recordName ? `${recordName}_EXPOSURE` : '';
      },
      bannerHasTitle() {
        const { banner } = this;
        const titleBanner = banner.filter(item => item.title);
        return titleBanner.length > 0;
      },
    },
    methods: {
      fetchCurrSlider() {
        const { swiperRefs, swiperOption } = this;
        const { loop } = swiperOption;
        const { realIndex, clickedIndex } = swiperRefs;
        const currentIndex = loop ? realIndex : clickedIndex;
        return this.banner.find((i, index) => index === currentIndex);
      },
      @decorator(before(function () {
        const item = this.fetchCurrSlider();
        this.$reporter.report(`${this.recordName}_CLICK`, Object.assign(item, { ymReporterRecordEntrySource: true }));
      }))
      handleClickSlider() {
        this.$emit('click', this.fetchCurrSlider());
      },
      setOptions(val) {
        this.swiperOption = Object.assign({}, this.swiperOption, val);
        this.swiperOption.loop = this.swiperOption.loop && this.banner.length > 1;
      },
    },
    created() {
      this.setOptions(this.options);
    },
    activated() {
      if (this.$refs.swiper) this.$refs.swiper.swiper.autoplay.start();
    },
    deactivated() {
      if (this.$refs.swiper) this.$refs.swiper.swiper.autoplay.stop();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @banner-item-border-radius: @border-radius-normal * 2;
  .banner {
    &-component {
      margin-left: -14px;
      padding-left: 14px;
      padding-bottom: @banner-shadow-bottom;

      &.has-title {
        .swiper-pagination {
          text-align: right;
          left: auto;
          right: @size-base;
          bottom: 18px;
        }

        /deep/ .swiper-pagination-bullet-active {
          background: @color-white;
        }
      }
      &.is-million-read {
        .swiper-pagination {
          text-align: center;
          left: auto;
          right: @size-base;
          bottom: 18px;
        }
        /deep/ .swiper-pagination-bullet-active {
          background: #ffc100;
        }
      }
    }

    &-item {
      width: 90%;
      height: 260px;
      border-radius: @banner-item-border-radius;
      overflow: hidden;

      &.has-shadow {
        box-shadow: 0 4px 7px 0 rgba(0, 0, 0, 0.19);
      }

      &.in-app {
        height: 35vw;
      }

      &-img {
        display: block;
        width: 100%;
        height: 100%;
        background-color: @background-color-base;
      }

      &-title {
        position: absolute;
        bottom: 0;
        box-sizing: border-box;
        display: flex;
        align-items: flex-end;
        width: 100%;
        height: 100px;
        padding: 14px 143px 14px 14px;
        font-size: @font-size-medium;
        color: @color-white;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
        border-radius: 0 0 4px 4px;
      }
    }
  }
</style>
